import { Route } from 'react-router-dom';

import { OnboardingCompletionGuard } from '@/app/router/OnboardingCompletionGuard';
import { ProtectedRoute } from '@/app/router/ProtectedRoute';

import { CustomizationScreen } from './pages/CustomizationScreen';

// /customization — authenticated + onboarding-complete, same guard chain as
// /settings (branding is a tenant-admin surface).
export const customizationRoutes = (
  <Route
    path="/customization"
    element={
      <ProtectedRoute>
        <OnboardingCompletionGuard>
          <CustomizationScreen />
        </OnboardingCompletionGuard>
      </ProtectedRoute>
    }
  />
);
